export enum POSDeviceOwnershipType{
    USER,
    MERCHANT,
    MERCHANT_GROUP,
    COST_CENTRE
}
